import {
  isAdvisoryFinding,
  isCheckFinding,
  isGenericFinding,
} from "~/pages/findings/FindingOnAsset/utils";
import {
  AdvisoryOnAssetFindingNode,
  CheckOnAssetFindingNode,
  CveOnAssetFindingNode,
  GenericFindingOnAssetFindingNode,
} from "~/pages/findings/FindingOnAsset/types";

type GetSummaryTextOptions = {
  advisoryDescription?: string | null;
};

/**
 * Gets the appropriate summary text based on the finding type
 * - Check findings: Use mquery description
 * - Generic findings: Use description field
 * - Advisory findings: Use advisory description from separate query
 * - Default: Use title as fallback
 */
export function getSummaryText(
  finding:
    | AdvisoryOnAssetFindingNode
    | CveOnAssetFindingNode
    | CheckOnAssetFindingNode
    | GenericFindingOnAssetFindingNode
    | undefined,
  options?: GetSummaryTextOptions,
): string {
  if (isCheckFinding(finding)) {
    return finding?.mquery?.docs?.desc || "";
  }

  if (isGenericFinding(finding)) {
    return finding?.description || "";
  }

  if (isAdvisoryFinding(finding) && options?.advisoryDescription) {
    return options.advisoryDescription;
  }

  return finding?.title || "";
}
